module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAALCAYAAACgR9dcAAAACXBIWXMAAAsSAAALEgHS3X78AAAA8UlEQVQoFXWSzVECURCEPygD4MKdDMAIgNoAdjIQM9AIhAwMQSOgCYBSMyAEPO8FqzxatVbjW1weS19mpma63/y8Xl3XdEHSCJgAtruIeM/LLsiSBsALUGa1n8CiLXJGTkQnx53t/OE2Inb2brLEQ4v4mOw38ANEEj40xSeypEkqaGD1t+TPI6Kd+ydLUseMxsovec6qLGbAYLjZqioLCx36kpZXiMYTsE++97GuysLLXDvuA1a8ho+G7BeBV+DO1rHJpwVkeE6x70xq9Ui0dWxyU5TDW5+28m77frjZLmwdH+8syaqeveu+X77CxQ8DfgHSf1RHTrwopgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/bimstream_failed.png
// module id = 12E2
// module chunks = 1